<template>
  <div>
    <div
      style="height: 70vh; overflow-y: scroll; overflow-x: hidden;"
      v-if="!isFolderOpen"
    >
      <div class="row workspaceFolders-header">
        <div class="col-12 col-sm-12 col-lg-8 col-xl-5 workspace-search-input">
          <b-input-group>
            <b-form-input placeholder="Поиск" v-model="searchName">
            </b-form-input>
          </b-input-group>
        </div>
        <div
          class="col-12 col-sm-12 col-lg-4 col-xl-1 workspace-search-buttons"
        >
          <b-button
            @click="onSearch"
            class="workspace-search-button"
            variant="primary"
            >Поиск</b-button
          >
        </div>
        <div class="col-12 col-sm-12 col-lg-10 col-xl-5 filter-btns-div">
          <b-button-group class="filter-btns">
            <b-button
              v-for="option in options"
              :key="option.value"
              :value="option.value"
              :variant="
                selectedFilters[option.value] === false
                  ? 'outline-primary'
                  : 'primary'
              "
              :disabled="filters[option.value] === false"
              @click="onFilterClick(option.value)"
            >
              {{ option.text }}
            </b-button>
          </b-button-group>
        </div>
        <div class="col-12 col-sm-12 col-lg-2 col-xl-1 workspace-load-button">
          <b-button
            id="loadButton"
            class="load-button"
            variant="outline-primary"
            style="float: right"
            @click="addFilesToWorkspace"
          >
            Загрузить
          </b-button>
          <b-form-file
            @change="loadFiles($event.target)"
            multiple
            plain
            hidden
            id="imageFileInput"
            :accept="acceptedTypes"
            ref="file-input"
          ></b-form-file>
        </div>
      </div>
      <div style="height: calc(100% - 42px)" class="mt-2">
        <b-card-group
          v-if="folders.length > 0"
          deck
          class="mb-2 workspace-folders"
        >
          <b-card
            v-for="(folder, index) in folders"
            :key="index"
            @click="goToSelectedFolder(index)"
            class="workspace-folder-card"
          >
            <img
              class="workspace-folder-image"
              src="/images/folder.png"
            />
            <br />
            <p class="folderDate">{{ folder.month }} {{ folder.year }}</p>
          </b-card>
        </b-card-group>
        <div v-else class="workspace-noFolders">
          <p>
            Отсутствуют файлы для добавления
          </p>
        </div>
      </div>
    </div>
    <div v-else style="height: 70vh; overflow-y: scroll; overflow-x: hidden;">
      <div class="workspace-header row">
        <div class="workspace-header-nav col-12 col-lg-6 col-xl-8">
          <span @click="returnToFolders()" style="cursor: pointer;"
            ><em class="fas fa-lg fa-arrow-left" aria-hidden="true"></em
          ></span>
          <div v-if="isSearch" class="ml-2" style="display: inline-block;">
            <h5>Результаты поиска</h5>
          </div>
          <div v-else class="ml-2" style="display: inline-block;">
            <h5>
              Файлы за {{ folders[chosenFolder].month }}
              {{ folders[chosenFolder].year }}
            </h5>
          </div>
        </div>
      </div>
      <div class="workspace-cards-div">
        <b-card-group v-if="files.length > 0" deck class="workspace-cards">
          <b-card
            v-for="(file, index) in this.files"
            :key="index"
            @click="selectFile(file.id)"
            :id="'file-' + file.id"
            style=" text-align: center; max-width: 244px; min-width: 244px; margin-top: 15px; cursor: pointer"
          >
            <em class="far fa-9x fa-file-pdf" v-if="file.type === 'pdf'"></em>
            <em
              class="far fa-9x fa-file-video"
              v-else-if="file.type === 'video'"
            ></em>
            <em class="fas fa-9x fa-wrench" v-else-if="file.type === 'swf'"></em>
            <em class="fas fa-9x fa-cubes" v-else-if="file.type === '3d'"></em>
            <em
              class="far fa-9x fa-file-audio"
              v-else-if="file.type === 'audio'"
            ></em>
            <img
              :src="'/api/files/' + file.physicalName"
              v-else-if="file.type === 'img' || file.type === 'avatar'"
              width="202"
              height="144"
            />
            <br />{{ file.name }}
          </b-card>
        </b-card-group>
        <div v-else class="workspace-noFolders">
          <p>
            Отсутствуют файлы для добавления
          </p>
        </div>
      </div>
      <div class="workspace-footer row">
        <div class="col-12 col-sm-12 col-lg-8">
          <b-input-group
            v-show="selectedFiles.length > 0"
            class="workspace-footer-selection"
          >
            <label class="workspace-footer-selection-label mr-2">
              Выбранные файлы:
            </label>
            <b-form-input
              id="selection"
              readonly
              @mousedown="focusSelection"
              @mouseout="blurSelection"
              :value="
                selectedFiles
                  .map((el) => '/api/files/' + el.physicalName)
                  .toString()
              "
            >
            </b-form-input>
          </b-input-group>
        </div>
        <div class="col-12 col-sm-12 col-lg-4 ml-auto">
          <b-button
            class="float-right workspace-footer-btn"
            variant="outline-primary"
            @click="addFilesFromWorkspace"
            float-right
            :disabled="!selectedFiles.length > 0"
          >
            Подтвердить
          </b-button>
        </div>
      </div>
    </div>
    <b-tooltip target="loadButton" placement="topleft">
      <p v-if="type === 'img' || type === 'avatar' || type === ''">
        Максимальный размер фотографии: 5MB
      </p>
      <p v-if="type === ''">
        Максимальный размер PDF: 5MB
      </p>
      <p v-if="type === 'video' || type === ''">
        Максимальный размер видео: 20MB
      </p>
    </b-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Workspace',
  props: {
    type: {
      type: String,
      default() {
        return ''
      }
    },
    fileHandler: {
      type: Function
    }
  },
  data() {
    return {
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getYear() + 1900,
      months: [
        { id: 0, title: 'Январь' },
        { id: 1, title: 'Февраль' },
        { id: 2, title: 'Март' },
        { id: 3, title: 'Апрель' },
        { id: 4, title: 'Май' },
        { id: 5, title: 'Июнь' },
        { id: 6, title: 'Июль' },
        { id: 7, title: 'Август' },
        { id: 8, title: 'Сентябрь' },
        { id: 9, title: 'Октябрь' },
        { id: 10, title: 'Ноябрь' },
        { id: 11, title: 'Декабрь' }
      ],
      chosenFolder: null,
      isFolderOpen: false,
      selectedFiles: [],
      searchName: '',
      isSearch: false,
      filters: {
        img: false,
        video: false,
        pdf: false,
        swf: false,
        '3d': false,
        audio: false
      },
      selectedFilters: {
        img: false,
        video: false,
        pdf: false,
        swf: false,
        '3d': false,
        audio: false
      },
      options: [
        { text: 'Изображения', value: 'img' },
        { text: 'Видео', value: 'video' },
        { text: 'PDF', value: 'pdf' }
      ],
      date: null
    }
  },
  computed: {
    acceptedTypes() {
      if (this.type === 'img' || this.type === 'avatar' || this.type.includes('preview')) {
        return 'image/jpeg, image/png'
      }
      if (this.type === 'video') {
        return '.mp4, .ogg, .ogv'
      }
      if (this.type === 'swf') {
        return '.swf'
      }
      if (this.type === '3d') {
        return '.obj'
      }
      if (this.type === 'resources') {
        return '.ogg, .mp3, image/jpeg, image/png, image/gif'
      }
      if (this.type === '') {
        return 'image/jpeg, image/png, .pdf, .mp4, .ogg, .ogv'
      }
      return ''
    },
    folders() {
      if (this.workspace) {
        return this.workspace
          .map((el) => {
            const year = el.split('-')[0]
            const month = this.months[el.split('-')[1] - 1].title
            return { year, month }
          })
          .reverse()
      }
      return []
    },
    ...mapGetters('workspace', {
      files: 'getFiles',
      workspace: 'getWorkspace'
    })
  },
  created() {
    if (this.$route.path.includes('training')) {
      this.options.push({ text: 'Аудио', value: 'audio' })
    } else {
      this.options.push(
        { text: 'Flash', value: 'swf' },
        { text: '3D', value: '3d' },
      )
    }
    if (this.type === '') {
      this.filters.img = true
      this.filters.pdf = true
      this.filters.video = true
      this.filters.swf = false
      this.filters['3d'] = false
      this.filters.audio = false
    } else if (this.type === 'img' || this.type === 'avatar' || this.type.includes('preview')) {
      this.filters.img = true
      this.filters.pdf = false
      this.filters.video = false
      this.filters.swf = false
      this.filters['3d'] = false
      this.selectedFilters.img = true
      this.filters.audio = false
    } else if (this.type === 'video') {
      this.filters.img = false
      this.filters.pdf = false
      this.filters.video = false
      this.filters.swf = false
      this.filters['3d'] = false
      this.filters.audio = false
      this.selectedFilters.video = true
    } else if (this.type === 'swf') {
      this.filters.img = false
      this.filters.pdf = false
      this.filters.video = false
      this.filters.swf = false
      this.filters['3d'] = false
      this.filters.audio = false
      this.selectedFilters.swf = true
    } else if (this.type === '3d') {
      this.filters.img = false
      this.filters.pdf = false
      this.filters.video = false
      this.filters.swf = false
      this.filters['3d'] = false
      this.selectedFilters['3d'] = true
      this.filters.audio = false
    } else if (this.type === 'resources') {
      this.filters.img = true
      this.filters.pdf = false
      this.filters.video = false
      this.filters.swf = false
      this.filters['3d'] = false
      this.filters.audio = true
      this.selectedFilters.img = true
      this.selectedFilters.audio = true
    }

    this.fetchWorkspace(this.getFilters())
  },
  methods: {
    goToSelectedFolder(id) {
      const date = {
        year: this.folders[id].year,
        month:
          this.months.filter((p) => p.title === this.folders[id].month)[0].id
          + 1
      }
      this.fetchFiles({ date, type: this.getFilters(), search: '' }).then(
        () => {
          this.chosenFolder = id
          this.isFolderOpen = true
          this.date = date
        },
      )
    },
    returnToFolders() {
      this.isFolderOpen = false
      for (let i = 0; i < this.selectedFiles.length; i++) {
        document
          .getElementById(`file-${this.selectedFiles[i].id}`)
          .classList.remove('selected-file')
      }
      this.selectedFiles = []
      this.date = null
      this.resetSearch()
    },
    selectFile(id) {
      const indexInSelectedFiles = this.selectedFiles.findIndex(
        (p) => p.id === id,
      )
      if (indexInSelectedFiles === -1) {
        if (this.type !== 'avatar' && !this.type.includes('preview')) {
          this.selectedFiles.push(this.files.filter((p) => p.id === id)[0])
          document.getElementById(`file-${id}`).classList.add('selected-file')
        } else {
          // если изменяем аватар
          this.selectedFiles.forEach((file) => document
            .getElementById(`file-${file.id}`)
            .classList.remove('selected-file'))
          this.selectedFiles = [this.files.filter((p) => p.id === id)[0]]
          document.getElementById(`file-${id}`).classList.add('selected-file')
        }
      } else {
        this.selectedFiles.splice(indexInSelectedFiles, 1)
        document.getElementById(`file-${id}`).classList.remove('selected-file')
      }
    },
    addFilesFromWorkspace() {
      if (this.fileHandler) {
        this.fileHandler(this.selectedFiles)
      } else if (this.type === '') {
        this.selectedFiles.forEach((el) => this.addLink(el))
        this.$bvModal.hide('files-upload-modal')
      } else if (this.type === 'img' || this.type === 'video') {
        if (this.$route.path.includes('courses')) {
          this.addNewFileToSubsection(this.selectedFiles).then(
            this.$bvModal.hide('files-upload-modal'),
          )
        } else {
          this.addNewFiles(this.selectedFiles).then(
            this.$bvModal.hide('files-upload-modal'),
          )
        }
      } else if (this.type === 'avatar') {
        this.changeAvatar(this.selectedFiles[0])
      } else if (this.type.includes('preview')) {
        this.changeVideoPreview({
          videoId: Number(this.type.split('-')[1]),
          description: this.selectedFiles[0].physicalName
        }).then(
          this.$bvModal.hide('files-upload-modal'),
        )
      } else if (this.type === 'swf') {
        this.addNewFileToSubsection(this.selectedFiles).then(
          this.$bvModal.hide('files-upload-modal'),
        )
      } else if (this.type === '3d') {
        this.addNewFileToSubsection(this.selectedFiles).then(
          this.$bvModal.hide('files-upload-modal'),
        )
      } else if (this.type === 'resources') {
        this.addNewFileToResources(this.selectedFiles).then(
          this.$bvModal.hide('resource-upload-modal'),
        )
      }
      this.updateContentSavedStatus(false)
      this.$bvModal.hide('files-upload-modal')
    },
    // загрузка с устройства
    async loadFiles(input) {
      if (input.files && input.files[0]) {
        const largeFiles = []
        for (const file of input.files) {
          const fileType = file.type.split('/')
          const fileSize = file.size / 1024 / 1024
          if ((fileType[0] === 'image' || ['x-shockwave-flash', 'pdf'].includes(fileType[1])) && fileSize > 5
            || (fileType[0] === 'video' || file.name.includes('.obj')) && fileSize > 20) {
            largeFiles.push(file.name)
          }
        }
        largeFiles.forEach((el) => this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: `При загрузке возникла ошибка. Файл: ${el} не был загружен в связи с превышением максимального размера!`
        }))
        const invalidFiles = []
        const correctSizeFiles = [...input.files].filter(
          (el) => !largeFiles.includes(el.name),
        )
        for (let i = 0; i < correctSizeFiles.length; ++i) {
          const mime = correctSizeFiles[i].type.split('/')[1]
          if (this.type === 'img' || this.type === 'avatar' || this.type.includes('preview')) {
            if (
              correctSizeFiles[i].type.split('/')[0] !== 'image'
              || !['jpeg', 'png'].includes(mime)
            ) {
              invalidFiles.push(correctSizeFiles[i].name)
            }
          } else if (this.type === 'video') {
            if (
              correctSizeFiles[i].type.split('/')[0] !== 'video'
              || !['mp4', 'ogg', 'ogv'].includes(mime)
            ) {
              invalidFiles.push(correctSizeFiles[i].name)
            }
          } else if (this.type === 'swf') {
            if (
              mime !== 'x-shockwave-flash'
              && mime !== 'vnd.adobe.flash.movie'
            ) {
              invalidFiles.push(correctSizeFiles[i].name)
            }
          } else if (this.type === '3d') {
            if (
              (input.files[i].type && mime !== 'x-tgif')
              || !input.files[i].name.includes('.obj')
            ) {
              invalidFiles.push(correctSizeFiles[i].name)
            }
          }
        }
        invalidFiles.forEach((el) => this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: `При загрузке возникла ошибка. Файл: ${el} не был загружен в связи с несоответствием типа!`
        }))
        // загружаем файлы в БД, получаем данные по загруженным файлам
        const uploadedFiles = await this.uploadFiles(
          correctSizeFiles.filter((el) => !invalidFiles.includes(el.name)),
        )
        if (this.fileHandler && uploadedFiles) {
          this.fileHandler(uploadedFiles.data)
        } else if (uploadedFiles) {
          const payload = {
            // преобразуем полученные данные для добавления их в контент страницы
            files: uploadedFiles.data.map((el) => {
              const newEl = {
                id: el.id,
                description: el.description,
                name: el.name,
                physicalName: el.physicalName,
                type: el.type
              }
              return newEl
            }),
            type: this.type
          }
          // меняем аватар, если выбрана его смена
          if (this.type === 'avatar') {
            await this.changeAvatar(uploadedFiles.data[0])
          } else if (this.type.includes('preview')) {
            await this.changeVideoPreview({
              videoId: Number(this.type.split('-')[1]),
              description: this.selectedFiles[0].physicalName
            })
          } else if (this.$route.path.includes('courses')) {
            // добавляем в контент страницы
            await this.addNewFileToSubsection(payload.files)
          } else if (this.$route.path.includes('training')) {
            await this.addNewFileToResources(payload.files)
            this.$bvModal.hide('resource-upload-modal')
          } else {
            await this.addNewLoadedFiles(payload)
          }
          // обновляем данные страницы
          await this.fetchWorkspace(this.getFilters())
          this.$refs['file-input'].reset()
          this.updateContentSavedStatus(false)
        }
        this.$bvModal.hide('files-upload-modal')
      }
    },
    addFilesToWorkspace() {
      document.getElementById('imageFileInput').click()
    },
    focusSelection() {
      if (!this.selectedFiles) {
        document.querySelector('.workspace-cards-div').style.overflow = 'hidden'
      }
    },
    blurSelection() {
      document.querySelector('.workspace-cards-div').style.overflow = 'auto'
    },
    onSearch() {
      this.isSearch = true
      if (this.searchName) {
        this.fetchFiles({
          date: null,
          type: this.getFilters(),
          search: this.searchName.split(' ')
        }).then(() => {
          this.isFolderOpen = true
        })
      }
    },
    resetSearch() {
      this.searchName = ''
      this.isSearch = false
    },
    async onFilterClick(filter) {
      this.selectedFilters[filter] = !this.selectedFilters[filter]
      await this.fetchWorkspace(this.getFilters())
    },
    getFilters() {
      const filters = []
      for (const [key, value] of Object.entries(this.selectedFilters)) {
        if (value) {
          filters.push(key)
        }
      }
      return filters
    },

    ...mapActions('workspace', [
      'fetchFiles',
      'uploadFiles',
      'fetchWorkspace'
    ]),
    ...mapActions('toasts', ['pushToasts']),
    ...mapActions('content', [
      'addNewFiles',
      'addNewLoadedFiles',
      'addLink',
      'changeAvatar',
      'changeVideoPreview'
    ]),
    ...mapActions({
      addNewFileToSubsection: 'education/addNewFileToSubsection',
      addNewFileToResources: 'training/addNewFileToResources'
    }),
    ...mapMutations({
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus'
    })
  }
}
</script>

<style scoped lang="scss">
.selected-file {
  background-color: #78d3ff;
}

.workspace-header {
  position: absolute;
  top: 5px;
  left: 15px;
  width: 100%;
  height: 40px;
  background-color: white;
  border-bottom: 1px solid rgb(221, 221, 221);
  z-index: 1;
}

.workspace-header-nav {
  margin-top: 6px;
}

.workspace-noFolders {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  text-align: center;
  font-size: 26px;
}

.workspace-cards-div {
  height: calc(100% - 39px);
}

.workspace-cards {
  padding-top: 30px;
  padding-bottom: 50px;
  justify-content: center !important;
}

.workspace-footer {
  position: absolute;
  bottom: 5px;
  left: 15px;
  height: 50px;
  width: 100%;
  background-color: white;
  border-top: 1px solid lightgrey;
}

.workspace-footer-btn {
  margin-top: 8px;
}

.workspace-footer-selection {
  margin-top: 8px;
}

.workspace-footer-selection-label {
  margin-top: 2px;
  display: inline-flex;
  align-items: center;
}

textarea:hover,
input:hover,
textarea:active,
input:active,
textarea:focus,
input:focus,
button:focus,
button:active,
button:hover,
button,
label:focus,
.btn:active,
.btn.active {
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
}

.card-body {
  padding-bottom: 5px;
}

.workspaceFolders-header {
  position: absolute;
  top: 10px;
  left: 15px;
  height: 40px;
  width: 100%;
  background-color: white;
  z-index: 1;
}

.workspaceFolders-header > div {
  background-color: white;
  margin: 0 !important;
  padding-top: 15px;
}

.workspace-folders {
  padding: 20px;
  padding-top: 40px;
  justify-content: center !important;
  align-items: center;
}

.workspace-folder-card {
  text-align: center;
  max-width: 244px;
  min-width: 244px;
  margin-top: 15px;
  cursor: pointer;
}

.workspace-folder-image {
  width: 90%;
  height: 60%;
}

.folderDate {
  padding: 0;
  font-size: 18px;
  margin-top: 5px;
  margin-bottom: 0;
}

.filter-btns {
  width: 94%;
}

@media only screen and (max-width: 991px) {
  .workspace-folders {
    padding: 140px;
  }

  .workspace-search-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .workspace-search-button {
    width: 100%;
  }

  .workspace-load-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0 !important;
  }

  .load-button {
    width: 100%;
    margin-left: -2px;
  }

  .workspace-footer {
    height: 100px;
  }

  .workspace-footer-btn {
    width: 100%;
  }

  .workspace-cards {
    padding-bottom: 95px;
    padding-top: 80px;
  }

  .filter-btns {
    width: 100%;
    margin-bottom: 15px;
  }

  .workspace-folders {
    padding-top: 200px;
  }

  .workspace-header {
    height: 90px;
  }
}

@media only screen and (max-width: 562px) {
  .workspace-folder-card {
    max-width: 160px;
    min-width: 160px;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .workspace-search-button {
    width: 94%;
  }

  .load-button {
    margin-right: 14px;
  }

  .filter-btns {
    width: 100%;
  }

  .filter-btns-div {
    padding-right: 11.5px !important;
  }

  .workspace-folders {
    padding-top: 110px;
  }
}
</style>
